/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TaskInfoRequestParametersObject } from "./TaskInfoRequestParametersObject";
import {
    TaskInfoRequestParametersObjectFromJSON,
    TaskInfoRequestParametersObjectFromJSONTyped,
    TaskInfoRequestParametersObjectToJSON,
} from "./TaskInfoRequestParametersObject";

/**
 *
 * @export
 * @interface TaskInfoAddRequest
 */
export interface TaskInfoAddRequest {
    /**
     *
     * @type {string}
     * @memberof TaskInfoAddRequest
     */
    deviceIdentity?: string;
    /**
     * Optional, use to delay the processing of the message
     * @type {Date}
     * @memberof TaskInfoAddRequest
     */
    scheduledTime?: Date;
    /**
     * Optional, used to set a custom TTL for the command message
     * @type {Date}
     * @memberof TaskInfoAddRequest
     */
    expiresAt?: Date;
    /**
     *
     * @type {string}
     * @memberof TaskInfoAddRequest
     */
    taskType?: TaskInfoAddRequestTaskTypeEnum;
    /**
     *
     * @type {TaskInfoRequestParametersObject}
     * @memberof TaskInfoAddRequest
     */
    requestParametersObject?: TaskInfoRequestParametersObject;
}

/**
 * @export
 */
export const TaskInfoAddRequestTaskTypeEnum = {
    HardReset: "HardReset",
    SoftReset: "SoftReset",
    UpdateFirmware: "UpdateFirmware",
    UpdatePayMateFirmware: "UpdatePayMateFirmware",
    StartCharge: "StartCharge",
    StopCharge: "StopCharge",
    UnlockConnector: "UnlockConnector",
    TriggerMessage: "TriggerMessage",
    ClearChargingProfile: "ClearChargingProfile",
    DisableEnableCharging: "DisableEnableCharging",
    ChangeConfiguration: "ChangeConfiguration",
    ChangeExtendedConfiguration: "ChangeExtendedConfiguration",
    SendMessage: "SendMessage",
    DeviceAlert: "DeviceAlert",
    LimitChargeTransaction: "LimitChargeTransaction",
    SetDefaultChargingProfile: "SetDefaultChargingProfile",
    Activate: "Activate",
    SolarOverride: "SolarOverride",
    SetCentralSystemPassThrough: "SetCentralSystemPassThrough",
    PauseResumeChargeTransaction: "PauseResumeChargeTransaction",
    UpdatePayMateConnectorPricing: "UpdatePayMateConnectorPricing",
    SaveDeviceLogFiles: "SaveDeviceLogFiles",
    PowerOutageSchedule: "PowerOutageSchedule",
    GridPowerRestoredNotification: "GridPowerRestoredNotification",
    KickConnection: "KickConnection",
    GetConfiguration: "GetConfiguration",
    SetCoreConfiguration: "SetCoreConfiguration",
    GetDistributionBoardRemoteProfiles: "GetDistributionBoardRemoteProfiles",
    SetDistributionBoardRemoteProfile: "SetDistributionBoardRemoteProfile",
    ClearDistributionBoardRemoteProfile: "ClearDistributionBoardRemoteProfile",
    WatchBalenaDevice: "WatchBalenaDevice",
    UpdateSupervision: "UpdateSupervision",
    SetDisplayedPrice: "SetDisplayedPrice",
    GetDisplayedPrice: "GetDisplayedPrice",
    StartOcppLogUpload: "StartOcppLogUpload",
} as const;
export type TaskInfoAddRequestTaskTypeEnum =
    (typeof TaskInfoAddRequestTaskTypeEnum)[keyof typeof TaskInfoAddRequestTaskTypeEnum];

/**
 * Check if a given object implements the TaskInfoAddRequest interface.
 */
export function instanceOfTaskInfoAddRequest(
    value: object,
): value is TaskInfoAddRequest {
    return true;
}

export function TaskInfoAddRequestFromJSON(json: any): TaskInfoAddRequest {
    return TaskInfoAddRequestFromJSONTyped(json, false);
}

export function TaskInfoAddRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TaskInfoAddRequest {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        scheduledTime:
            json["scheduledTime"] == null
                ? undefined
                : new Date(json["scheduledTime"]),
        expiresAt:
            json["expiresAt"] == null ? undefined : new Date(json["expiresAt"]),
        taskType: json["taskType"] == null ? undefined : json["taskType"],
        requestParametersObject:
            json["requestParametersObject"] == null
                ? undefined
                : TaskInfoRequestParametersObjectFromJSON(
                      json["requestParametersObject"],
                  ),
    };
}

export function TaskInfoAddRequestToJSON(
    value?: TaskInfoAddRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        scheduledTime:
            value["scheduledTime"] == null
                ? undefined
                : value["scheduledTime"].toISOString(),
        expiresAt:
            value["expiresAt"] == null
                ? undefined
                : value["expiresAt"].toISOString(),
        taskType: value["taskType"],
        requestParametersObject: TaskInfoRequestParametersObjectToJSON(
            value["requestParametersObject"],
        ),
    };
}
